import { frontendURL } from '../../../helper/URLHelper';
import Whitelist from './Index.vue';
import store from '../../../store/index';
import { subscriptionGuard } from '../../../helper/subscriptionHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/whitelist'),
      name: 'whitelist',
      component: Whitelist,
      meta: {
        permissions: ['administrator'],
      },
      beforeEnter: async (to, from, next) => {
        await subscriptionGuard(to, from, next, store);
      },
    }
  ],
};
